( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-blocked-field input').each(function () {
			$(this).attr('disabled', 'disabled');
		});
	});
} )( jQuery, document, window );